import { Injectable } from "@angular/core";
import { App } from "@capacitor/app";
import { Platform } from "@ionic/angular";
import { LogoutService } from "../logout/logout.service";
import { AuthenticationService } from "../authentication/authentication.service";
import { ConfigService } from "../config/config.service";
import { sortBy } from "../codeUtils";

@Injectable({
    providedIn: 'root'
})

export class SiteMenuService {
    constructor(
        private readonly authenticationService: AuthenticationService,
        private readonly config: ConfigService,
        private readonly logoutService: LogoutService,
        private readonly platform: Platform,
    ) {

    }

    get isMobileApp(): boolean {
        return this.platform.is("capacitor");
    }

    public async getAppVersion(): Promise<string> {
        let versionNumber: string = "N/A";
        if (this.platform.is("capacitor")) {
            const info = await App.getInfo()
            versionNumber = info.version;
        }

        return versionNumber;
    }

    public logout(): any {
        return this.logoutService.onLogout();
    }

    public checkPlayerHasRewardCard() {
        let playerHasRewardCard: any;
        this.authenticationService.checkPlayerHasRewardCard().subscribe(
            (response) => {
                if (response && !!response.result) {
                    playerHasRewardCard = response.payload;
                }
            },
            (error) => {
                playerHasRewardCard = false;
            }
        );

        return playerHasRewardCard;
    }

    public getSiteMenu(): any {
        const externalLinks: any = this.config?.getExternalLinks();

        const linksArray = Array.isArray(externalLinks?.payload) ? externalLinks.payload : [];

        return linksArray
            .map(link => {
                link.active = false;
                return link;
            })
            .filter(link => link.isHamburgerMenu === 1)
            .sort(sortBy('lobbyNavBarPosition'));
    }


}